module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.visible) ? _c('source-dialog-view', {
    ref: "dialogView",
    attrs: {
      "content": _vm.content,
      "action": _vm.action
    },
    on: {
      "set-content": _vm.setContent,
      "add-complete": _vm.onAddComplete,
      "edit-complete": _vm.onEditComplete,
      "close": function($event) {
        _vm.visible = false
      }
    }
  }) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3e8046a8"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/SourceDialogContainer.vue
// module id = 1006
// module chunks = 1